import classnames from 'classnames'
import React from 'react'

import { Loading } from 'modules/ui'
import enhance from './enhancers'

export function Image(props) {
  const {
    children,
    className,
    handleImageLoad,
    imageLoaded,
    src,
    theme,
  } = props

  const classNames = classnames(className, theme.image, {
    [theme.imageLoaded]: imageLoaded
  })

  return (
        <div className={classNames}>
          <Loading active={!imageLoaded} />
          <div className={theme.container}>
            <img
                role='presentation'
                src={src}
                onLoad={handleImageLoad} />
            <div className={theme.content}>
              {children}
            </div>
          </div>
        </div>
  )
}

export default enhance(Image)



// WEBPACK FOOTER //
// ./client/modules/ui/components/Image/index.js